import setup from './moduleSetup';

export default {
    name: 'customAttributes',
    before: [],
    after: [],
    setup,
};
